import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";

const Sidebar = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const language = sessionStorage.getItem("preferred-language") || "English";

  const translations = {
    English: {
      analyticsDashboard: "Analytics Dashboard",
      userManagement: "User Management",
      adminOperations: "Admin Operations & Logs",
      followUs: "FOLLOW US ON",
    },
    Japanese: {
      analyticsDashboard: "分析ダッシュボード",
      userManagement: "ユーザー管理",
      adminOperations: "管理操作とログ",
      followUs: "フォローする",
    },
  };

  const t = translations[language];

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const closeSidebar = () => {
    setShowSidebar(false);
  };

  return (
    <>
      <button
        className={`mobile-menu-btn ${showSidebar ? "show" : ""}`}
        onClick={toggleSidebar}
      >
        {showSidebar ? <FaTimes /> : <FaBars />}
      </button>

      {/* Overlay */}
      <div
        className={`sidebar-overlay ${showSidebar ? "show" : ""}`}
        onClick={closeSidebar}
      />

      <div
        className={`MockMain-sidebar d-flex flex-column gap-4 ${
          showSidebar ? "show" : ""
        }`}
      >
        <NavLink
          className={({ isActive }) =>
            `sidebarnav ${isActive ? "active-link" : ""}`
          }
          to="/analytics-dashboard"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 21 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0.281738 18.9484V6.94836L8.28174 0.948364L16.2817 6.94836V18.9484H10.2817V11.9484H6.28174V18.9484H0.281738Z" />
          </svg>
          {t.analyticsDashboard}
        </NavLink>

        <NavLink
          className={({ isActive }) =>
            `sidebarnav ${isActive ? "active-link" : ""}`
          }
          to="/user-management"
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.4927 6.5833C4.33991 6.933 4.25372 7.31841 4.25011 7.72353L4.25 7.75V11.25H0.75V8.91668C0.75 7.64038 1.77339 6.60424 3.04474 6.58365L3.08332 6.58332L4.4927 6.5833ZM8.91665 5.41668C10.2054 5.41668 11.25 6.46134 11.25 7.75V11.25H4.83332V7.75C4.83332 6.46134 5.87799 5.41668 7.16668 5.41668H8.91665ZM3.66668 2.5C4.63153 2.5 5.41668 3.28518 5.41668 4.25C5.41668 5.21482 4.63153 6 3.66668 6C2.70185 6 1.91668 5.21482 1.91668 4.25C1.91668 3.28518 2.70185 2.5 3.66668 2.5ZM8.04168 0.75C9.16753 0.75 10.0834 1.66582 10.0834 2.79168C10.0834 3.91753 9.16753 4.83332 8.0417 4.83332C6.91585 4.83332 6.00003 3.9175 6.00003 2.79168C6 1.66582 6.91582 0.75 8.04168 0.75Z"
              fill="#686868"
            />
          </svg>
          {t.userManagement}
        </NavLink>
        <NavLink
          className={({ isActive }) =>
            `sidebarnav ${isActive ? "active-link" : ""}`
          }
          to="/admin-operations"
        >
          <svg
            width="11"
            height="13"
            viewBox="0 0 11 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.0026 8.16671V12.8334H0.335938C0.335938 11.5957 0.827603 10.4087 1.70277 9.53354C2.57794 8.65837 3.76493 8.16671 5.0026 8.16671ZM5.0026 7.58337C3.06885 7.58337 1.5026 6.01712 1.5026 4.08337C1.5026 2.14962 3.06885 0.583374 5.0026 0.583374C6.93635 0.583374 8.5026 2.14962 8.5026 4.08337C8.5026 6.01712 6.93635 7.58337 5.0026 7.58337ZM10.2526 9.91671H10.8359V12.8334H6.16927V9.91671H6.7526V9.33337C6.7526 8.86924 6.93698 8.42413 7.26517 8.09594C7.59336 7.76775 8.03848 7.58337 8.5026 7.58337C8.96673 7.58337 9.41185 7.76775 9.74004 8.09594C10.0682 8.42413 10.2526 8.86924 10.2526 9.33337V9.91671ZM9.08594 9.91671V9.33337C9.08594 9.17866 9.02448 9.03029 8.91508 8.92089C8.80569 8.8115 8.65731 8.75004 8.5026 8.75004C8.34789 8.75004 8.19952 8.8115 8.09012 8.92089C7.98073 9.03029 7.91927 9.17866 7.91927 9.33337V9.91671H9.08594Z"
              fill="#686868"
            />
          </svg>
          {t.adminOperations}
        </NavLink>

        {/* Follow Us Section */}
        <div className="follow-us p-3">
          <p className="mb-3">{t.followUs}</p>
          <div className="social-icons d-flex align-item-center justify-content-around gap-1">
            <a
              href="https://www.linkedin.com/company/hr-hatch/?viewAsMember=true&fbclid=IwZXh0bgNhZW0CMTEAAR04-4YiMGiy8P8WBncX6i1SV_ojpFaXku3y8a6sW17Cnxag9zYkgTPrmPU_aem_17xurdIqUzSoNuVh-ZcU4w"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M15.053 0H4.447C3.26758 0 2.13647 0.468522 1.3025 1.3025C0.468522 2.13647 0 3.26758 0 4.447V15.053C0 16.2324 0.468522 17.3635 1.3025 18.1975C2.13647 19.0315 3.26758 19.5 4.447 19.5H15.053C16.2324 19.5 17.3635 19.0315 18.1975 18.1975C19.0315 17.3635 19.5 16.2324 19.5 15.053V4.447C19.5 3.26758 19.0315 2.13647 18.1975 1.3025C17.3635 0.468522 16.2324 0 15.053 0ZM6.593 15.742C6.59614 15.7964 6.58811 15.8509 6.56942 15.9021C6.55072 15.9534 6.52176 16.0002 6.4843 16.0398C6.44684 16.0794 6.40167 16.111 6.35158 16.1325C6.30149 16.154 6.24752 16.1651 6.193 16.165H4.413C4.30566 16.1624 4.20362 16.1178 4.12883 16.0407C4.05403 15.9637 4.01244 15.8604 4.013 15.753V8.35C4.01153 8.29655 4.02079 8.24335 4.04023 8.19355C4.05967 8.14374 4.0889 8.09834 4.1262 8.06002C4.16349 8.0217 4.20808 7.99125 4.25734 7.97047C4.3066 7.94968 4.35953 7.93898 4.413 7.939H6.193C6.24647 7.93898 6.2994 7.94968 6.34866 7.97047C6.39792 7.99125 6.44251 8.0217 6.4798 8.06002C6.5171 8.09834 6.54633 8.14374 6.56577 8.19355C6.58521 8.24335 6.59447 8.29655 6.593 8.35V15.742ZM5.27 6.382C5.07729 6.38056 4.88674 6.34117 4.70925 6.26608C4.53176 6.191 4.37079 6.08169 4.23554 5.9444C4.10029 5.80711 3.99341 5.64452 3.921 5.46593C3.84858 5.28733 3.81206 5.09621 3.8135 4.9035C3.81494 4.71079 3.85433 4.52024 3.92942 4.34275C4.0045 4.16526 4.11381 4.00429 4.2511 3.86904C4.38839 3.73379 4.55098 3.62691 4.72957 3.5545C4.90817 3.48208 5.09929 3.44556 5.292 3.447C5.67452 3.45944 6.03703 3.62087 6.30219 3.89686C6.56734 4.17284 6.71415 4.54152 6.71128 4.92423C6.7084 5.30694 6.55609 5.67337 6.28682 5.94535C6.01755 6.21732 5.65266 6.3733 5.27 6.38M16.087 15.73C16.0865 15.831 16.0469 15.928 15.9764 16.0003C15.9058 16.0727 15.81 16.1149 15.709 16.118H13.83C13.7288 16.1149 13.6328 16.0726 13.5623 16C13.4918 15.9274 13.4522 15.8302 13.452 15.729V12.305C13.452 11.794 13.608 10.082 12.096 10.082C10.917 10.082 10.684 11.282 10.639 11.816V15.807C10.639 15.9084 10.5996 16.0058 10.529 16.0786C10.4585 16.1514 10.3623 16.1939 10.261 16.197H8.438C8.33474 16.1967 8.2358 16.1555 8.16287 16.0824C8.08995 16.0093 8.049 15.9103 8.049 15.807V8.314C8.05212 8.21266 8.09458 8.11652 8.16739 8.04595C8.24019 7.97539 8.33761 7.93595 8.439 7.936H10.261C10.3624 7.93595 10.4598 7.97539 10.5326 8.04595C10.6054 8.11652 10.6479 8.21266 10.651 8.314V8.959C10.917 8.56962 11.2843 8.26027 11.7133 8.0643C12.1422 7.86834 12.6165 7.7932 13.085 7.847C16.12 7.847 16.109 10.682 16.109 12.294L16.087 15.73Z" />
              </svg>
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M2.78571 0C1.24922 0 0 1.24922 0 2.78571V16.7143C0 18.2508 1.24922 19.5 2.78571 19.5H16.7143C18.2508 19.5 19.5 18.2508 19.5 16.7143V2.78571C19.5 1.24922 18.2508 0 16.7143 0H2.78571ZM15.7175 3.65625L11.1994 8.81853L16.5141 15.8438H12.3529L9.0971 11.5825L5.36685 15.8438H3.29933L8.1308 10.3202L3.03382 3.65625H7.29944L10.2462 7.5519L13.65 3.65625H15.7175ZM14.0722 14.6076L6.67701 4.82712H5.4452L12.9231 14.6076H14.0679H14.0722Z" />
              </svg>
            </a>
            <a
              href="https://www.facebook.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M19.5 9.77444C19.5 4.37895 15.132 0 9.75 0C4.368 0 0 4.37895 0 9.77444C0 14.5053 3.354 18.4444 7.8 19.3534V12.7068H5.85V9.77444H7.8V7.33083C7.8 5.44436 9.33075 3.90977 11.2125 3.90977H13.65V6.8421H11.7C11.1638 6.8421 10.725 7.28195 10.725 7.81955V9.77444H13.65V12.7068H10.725V19.5C15.6488 19.0113 19.5 14.8474 19.5 9.77444Z" />
              </svg>
            </a>
            <a
              href="https://www.instagram.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.396 16.1644L16.3841 16.1666L16.3072 16.2045L16.2855 16.2088L16.2704 16.2045L16.1934 16.1666C16.1819 16.163 16.1732 16.1648 16.1674 16.172L16.1631 16.1828L16.1447 16.6465L16.1501 16.6682L16.1609 16.6822L16.2736 16.7624L16.2899 16.7667L16.3029 16.7624L16.4155 16.6822L16.4285 16.6649L16.4329 16.6465L16.4144 16.1839C16.4115 16.1723 16.4054 16.1658 16.396 16.1644ZM16.6831 16.042L16.669 16.0442L16.4686 16.1449L16.4578 16.1557L16.4545 16.1677L16.474 16.6335L16.4794 16.6465L16.4881 16.6541L16.7059 16.7548C16.7196 16.7584 16.73 16.7555 16.7373 16.7462L16.7416 16.731L16.7048 16.0658C16.7012 16.0528 16.6939 16.0449 16.6831 16.042ZM15.9085 16.0442C15.9037 16.0413 15.898 16.0403 15.8926 16.0415C15.8871 16.0427 15.8824 16.046 15.8793 16.0507L15.8728 16.0658L15.8359 16.731C15.8367 16.744 15.8428 16.7527 15.8544 16.757L15.8706 16.7548L16.0884 16.6541L16.0992 16.6454L16.1035 16.6335L16.1219 16.1677L16.1187 16.1547L16.1079 16.1438L15.9085 16.0442Z"
                  fill="#686868"
                />
                <path
                  d="M14.0833 0C15.5199 0 16.8977 0.570683 17.9135 1.5865C18.9293 2.60233 19.5 3.98008 19.5 5.41667V14.0833C19.5 15.5199 18.9293 16.8977 17.9135 17.9135C16.8977 18.9293 15.5199 19.5 14.0833 19.5H5.41667C3.98008 19.5 2.60233 18.9293 1.5865 17.9135C0.570683 16.8977 0 15.5199 0 14.0833V5.41667C0 3.98008 0.570683 2.60233 1.5865 1.5865C2.60233 0.570683 3.98008 0 5.41667 0H14.0833ZM9.75 5.41667C8.60073 5.41667 7.49853 5.87321 6.68587 6.68587C5.87321 7.49853 5.41667 8.60073 5.41667 9.75C5.41667 10.8993 5.87321 12.0015 6.68587 12.8141C7.49853 13.6268 8.60073 14.0833 9.75 14.0833C10.8993 14.0833 12.0015 13.6268 12.8141 12.8141C13.6268 12.0015 14.0833 10.8993 14.0833 9.75C14.0833 8.60073 13.6268 7.49853 12.8141 6.68587C12.0015 5.87321 10.8993 5.41667 9.75 5.41667ZM9.75 7.58333C10.3246 7.58333 10.8757 7.81161 11.2821 8.21794C11.6884 8.62426 11.9167 9.17536 11.9167 9.75C11.9167 10.3246 11.6884 10.8757 11.2821 11.2821C10.8757 11.6884 10.3246 11.9167 9.75 11.9167C9.17536 11.9167 8.62426 11.6884 8.21794 11.2821C7.81161 10.8757 7.58333 10.3246 7.58333 9.75C7.58333 9.17536 7.81161 8.62426 8.21794 8.21794C8.62426 7.81161 9.17536 7.58333 9.75 7.58333ZM14.625 3.79167C14.3377 3.79167 14.0621 3.9058 13.859 4.10897C13.6558 4.31213 13.5417 4.58768 13.5417 4.875C13.5417 5.16232 13.6558 5.43787 13.859 5.64103C14.0621 5.8442 14.3377 5.95833 14.625 5.95833C14.9123 5.95833 15.1879 5.8442 15.391 5.64103C15.5942 5.43787 15.7083 5.16232 15.7083 4.875C15.7083 4.58768 15.5942 4.31213 15.391 4.10897C15.1879 3.9058 14.9123 3.79167 14.625 3.79167Z"
                  // fill="#686868"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
